export const EXTENSION_SECRET_KEY = "EXTENSION_SECRET_KEY";
